import { useEffect, useRef } from 'react';

import { useAppContext } from '@/app/components/providers/AppContextProvider';
import { LogoType } from '@/app/shared/constants/companies/company.types';
import { useOktaAuth } from '@okta/okta-react';
import OktaSignIn from '@okta/okta-signin-widget';
import '@okta/okta-signin-widget/css/okta-sign-in.min.css';
import { PageRoutes } from '../../../components/router/routes';
import { getCompanyData } from '../../../shared/constants/companies';

export const SignIn = () => {
  const { theme } = useAppContext();

  // call hooks
  const { oktaAuth } = useOktaAuth();
  const signInWidgetRef = useRef<OktaSignIn | null>(null);

  useEffect(() => {
    const { environmentConfig, logos } = getCompanyData();

    // Initialize the Okta Sign-In Widget with proper configuration
    const signInWidget = new OktaSignIn({
      baseUrl: environmentConfig.issuer.replace('/oauth2/default', ''),
      clientId: environmentConfig.clientId,
      redirectUri: `${environmentConfig.baseUrl}${PageRoutes.CALLBACK}`,
      authParams: {
        issuer: environmentConfig.issuer,
        responseType: ['code'],
        scopes: ['openid', 'profile', 'email'],
      },
      colors: {
        brand: theme.colors.dataVisualization.teal,
      },
      logo: logos[LogoType.SMALL],
      helpLinks: {
        custom: [
          {
            text: 'Send activation email',
            href: PageRoutes.RESEND_ACTIVATION,
          },
        ],
      },
    });

    signInWidgetRef.current = signInWidget;

    signInWidget
      .showSignInToGetTokens({
        el: '#osw-container',
      })
      .then(function (tokens) {
        // Handle successful authentication
        if (tokens.accessToken && tokens.idToken) {
          // Store tokens using the oktaAuth instance
          // Auth State gets updated and redirects to /dashboard
          oktaAuth.tokenManager.setTokens(tokens);
        }
      })
      .catch(function (error) {
        console.error('Okta Sign-In Widget error:', error);
      });

    // Cleanup function
    return () => {
      if (signInWidgetRef.current) {
        signInWidgetRef.current.remove();
        signInWidgetRef.current = null;
      }
    };
  }, [oktaAuth]);

  return <div id="osw-container" />;
};
